import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const appRegisterationService = {
    searchUsers: async (payload) => {
         try {
            const response = await axios.post(`${API_ENDPOINT}user/searchuser`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    appRegistrationSubmit: async (payload) => {
         try {
            const response = await axios.post(`${API_ENDPOINT}entra/app-registration/submit`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    getPermissions: async () => {
         try {
            const response = await axios.get(`${API_ENDPOINT}entra/app-registration/permissions`);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    }
    
};

export default appRegisterationService;